import { render, staticRenderFns } from "./InventorySettings.vue?vue&type=template&id=65363da4"
import script from "./InventorySettings.vue?vue&type=script&lang=js"
export * from "./InventorySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports